import {Link, Stack} from "@mui/material";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import {Link as RouterLink} from "react-router";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import AppRoute from "../routing/AppRoute";

export const ProjectsSection = () => (
    <Stack>
        <Stack spacing={2}>
            <Stack direction="row" alignItems="center" spacing={1}>
                <TaskAltIcon color="secondary"/>
                <Link
                    underline="hover"
                    component={RouterLink}
                    to={AppRoute.CITY_PINNER}
                    sx={{color: "text.primary"}}
                >
                    CITYPINNER
                </Link>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
                <TaskAltIcon color="secondary"/>
                <Link
                    underline="hover"
                    component={RouterLink}
                    to={AppRoute.CV_APP}
                    sx={{color: "text.primary"}}
                >
                    CV App
                </Link>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
                <TaskAltIcon color="secondary"/>
                <Link
                    underline="hover"
                    component={RouterLink}
                    to={AppRoute.ASC}
                    sx={{color: "text.primary"}}
                >
                    Aventură și Călătorii
                </Link>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
                <TaskAltIcon color="secondary"/>
                <Link
                    underline="hover"
                    component={RouterLink}
                    to={AppRoute.CHIRON}
                    sx={{color: "text.primary"}}
                >
                    Taberele Chiron
                </Link>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
                <TaskAltIcon color="secondary"/>
                <Link
                    underline="hover"
                    component={RouterLink}
                    to={AppRoute.ATLAS}
                    sx={{color: "text.primary"}}
                >
                    Atlas Travel
                </Link>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
                <TaskAltIcon color="secondary"/>
                <Link
                    underline="hover"
                    component={RouterLink}
                    to={AppRoute.ONCRUITER}
                    sx={{color: "text.primary"}}
                >
                    oncruiter
                </Link>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
                <BuildCircleIcon color="secondary"/>
                <Link
                    underline="hover"
                    component={RouterLink}
                    to="https://www.librarii-astrorum.com/"
                    target="_blank"
                    sx={{color: "text.primary"}}
                >
                    Librarii Astrorum (work in progress)
                </Link>
            </Stack>
        </Stack>
    </Stack>
)